<template>
  <div>
    <h2> News </h2>
    <div class="news">
        <div v-for="(article, idx) of newsarticles" :key="idx">
          <NewsArticleDetail :article="article"/>
        </div>
    </div>
  </div>
</template>

<script>
import NewsArticleDetail from '../components/NewsArticleDetail.vue'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'News',
  components: {
    NewsArticleDetail
  },

  metaInfo: {
    title: 'Eats On Feets - News',
    titleTemplate: null
  },

  computed: mapState({
    newsarticles: state => state.newsarticles.newsarticles
  }),

  methods: {
    ...mapActions('newsarticles', [
      'loadNewsArticles'
    ])
  },

  mounted() {
    this.loadNewsArticles()
  }

}
</script>

<style lang="scss" scoped>
.news {
  text-align: left;
  padding-left: 10px;
  padding-bottom: 40px;
}
</style>
